import { render, staticRenderFns } from "./SalesGallerySection.vue?vue&type=template&id=9dca3398&"
import script from "./SalesGallerySection.vue?vue&type=script&lang=js&"
export * from "./SalesGallerySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dca3398')) {
      api.createRecord('9dca3398', component.options)
    } else {
      api.reload('9dca3398', component.options)
    }
    module.hot.accept("./SalesGallerySection.vue?vue&type=template&id=9dca3398&", function () {
      api.rerender('9dca3398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/SalesGallerySection.vue"
export default component.exports